/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Stack, StackDivider } from '@chakra-ui/react';
import { type FC } from 'react';
import { type Frame } from '../../interface/Crash';
import { BindingsItem } from '../report/BindingsItem';

interface Props {
    callstack: Frame[];
    fileVersion?: string;
    lineNumber?: number;
}

export const CallstackView: FC<Props> = (props: Props) => {
    const { callstack, fileVersion, lineNumber } = props;

    return (
        <Stack spacing={2} mt={5} divider={<StackDivider pb={0} />}>
            {callstack.map((item, index) => {
                const versionMatch = item.version === fileVersion;
                const lineMatch = item.currentline === lineNumber;
                return (
                    <BindingsItem
                        key={index}
                        frame={item}
                        highlightColor={versionMatch && lineMatch ? 'orange' : undefined}
                    />
                );
            })}
        </Stack>
    );
};
